module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/qualification/qualification.component.css
// module id = ./src/app/Pages/manage/qualification/qualification.component.css
// module chunks = main